import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { GeneralLayout } from '@hero/layouts';

const LocalLayout = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 458px;
  text-align: center;
  width: 100%;
`;

export default function Layout({ children, activeStep, isLoading }) {
  return (
    <GeneralLayout activeStep={activeStep} isLoading={isLoading}>
      <LocalLayout>{children}</LocalLayout>
    </GeneralLayout>
  );
}

Layout.propTypes = {
  children: PropTypes.node,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      isCompleted: PropTypes.bool
    })
  ),
  activeStep: PropTypes.number,
  isLoading: PropTypes.bool
};
